import {UI} from "../../../../../../stem-core/src/ui/UI";

import {BlinkButton} from "../../../../../ui/Button";
import {Messages} from "../../../../../Messages";
import {PaymentMethodStore} from "../../../../../../client/state/PaymentMethodStore.js";
import {WalletStore} from "../../../../../../client/state/WalletStore.js";
import {ADD_FUNDS_DISABLE_TIMEOUT} from "../../../../../Constants";
import {Toast} from "../../../../../ui/Toast";
import {LoadingSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {Money} from "../../../../../../client/state/misc/Money";
import {apiUserTopUp, TopUpStatus} from "../../../../../../client/state/TopUpPaymentStore";


export class AddFundsButton extends BlinkButton {
    getDefaultOptions(options) {
        return {
            ...super.getDefaultOptions(options),
            amount: 0,
            userWallet: WalletStore.getWallet(),
            onClick: () => this.addFunds(),
            onNoPaymentMethod: null, // Required to be passed in
        };
    }

    render() {
        const {amount, userWallet} = this.options;
        const moneyAmount = new Money(amount, userWallet.getCurrency());
        return Messages.addFundsAmount(moneyAmount.toMainUnitString({decimalsDisplayed: 0}));
    }

    async addFunds() {
        const {amount, userWallet, onNoPaymentMethod} = this.options;
        const primaryCard = PaymentMethodStore.getPrimary();
        if (!primaryCard) {
            onNoPaymentMethod();
            return;
        }
        Toast.hide();
        this.tempDisable(ADD_FUNDS_DISABLE_TIMEOUT);

        try {
            const transaction = await LoadingSpinner.wrap(() => apiUserTopUp(amount, primaryCard, userWallet));
            if (transaction.status !== TopUpStatus.SUCCEEDED) {
                throw null;
            }
        } catch (error) {
            Toast.showError(error, Messages.failedAddFunds);
        }
    }
}
